import { ContentViewModel } from '@levelapp/softfabric';
import { Animated, Easing } from 'react-native';
export default class ButtonViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.initialState({
            scale: new Animated.Value(1),
            opacity: new Animated.Value(1),
            buttonTranslateX: new Animated.Value(1),
            buttonTranslateY: new Animated.Value(1),
        });
        this.getMyStyle = this.getMyStyle.bind(this);
        this.startAnimation = this.startAnimation.bind(this);
        this.startAnimationScale = this.startAnimationScale.bind(this);
        this.leaveAnimationScale = this.leaveAnimationScale.bind(this);
        this.startAnimationOpacity = this.startAnimationOpacity.bind(this);
        this.leaveAnimationOpacity = this.leaveAnimationOpacity.bind(this);
        this.startAnimationButtonX = this.startAnimationButtonX.bind(this);
        this.startAnimationButtonY = this.startAnimationButtonY.bind(this);
        this.leaveAnimationButtonX = this.leaveAnimationButtonX.bind(this);
        this.leaveAnimationButtonY = this.leaveAnimationButtonY.bind(this);
    }
    handleOnPress() {
        this.startAnimation();
        this.props().handleClick();
    }
    startAnimationScale() {
        Animated.timing(this.state().scale, {
            duration: 50,
            useNativeDriver: true,
            easing: Easing.elastic(0),
            toValue: 0.95,
        }).start(() => this.leaveAnimationScale());
    }
    leaveAnimationScale() {
        Animated.timing(this.state().scale, {
            duration: 100,
            useNativeDriver: true,
            easing: Easing.elastic(0),
            toValue: 1,
        }).start();
    }
    startAnimationOpacity() {
        Animated.timing(this.state().opacity, {
            duration: 50,
            useNativeDriver: true,
            toValue: 0,
        }).start(() => this.leaveAnimationOpacity());
    }
    leaveAnimationOpacity() {
        Animated.timing(this.state().opacity, {
            duration: 100,
            useNativeDriver: true,
            easing: Easing.elastic(0),
            toValue: 1,
        }).start();
    }
    startAnimationButtonY() {
        Animated.spring(this.state().buttonTranslateY, {
            speed: 300,
            useNativeDriver: true,
            toValue: 0,
        }).start(() => this.leaveAnimationButtonY());
    }
    startAnimationButtonX() {
        Animated.spring(this.state().buttonTranslateX, {
            speed: 300,
            useNativeDriver: true,
            toValue: 0,
        }).start(() => this.leaveAnimationButtonX());
    }
    leaveAnimationButtonY() {
        Animated.spring(this.state().buttonTranslateY, {
            speed: 300,
            useNativeDriver: true,
            toValue: 1,
        }).start();
    }
    leaveAnimationButtonX() {
        Animated.spring(this.state().buttonTranslateX, {
            speed: 300,
            useNativeDriver: true,
            toValue: 1,
        }).start();
    }
    startAnimation() {
        if (this.props().animation == "Bounce") {
            this.startAnimationScale();
        }
        else if (this.props().animation == "Button") {
            this.startAnimationButtonX();
            this.startAnimationButtonY();
        }
        else if (this.props().animation == "Opacity") {
            this.startAnimationOpacity();
        }
        else {
        }
    }
    getMyStyle() {
        if (this.props().borders == "None") {
            return this.style().noBorderRadius;
        }
        else if (this.props().borders == "Little") {
            return this.style().borderRadiusLittle;
        }
        else if (this.props().borders == "Rectangle") {
            return this.style().borderRadius;
        }
        return this.style().noBorderRadius;
    }
}
